import { create } from "zustand";

interface ParentDocumentState {
  parent: string | undefined;
  setParent: (prop: string | undefined) => void;
}

export const useParentDocument = create<ParentDocumentState>((set) => ({
  parent: undefined,
  setParent: (value) => set(() => ({ parent: value })),
}));
